export function TabContent({ children, cols = 3, classNames }) {
    return <div className={`cot-tab-content mt-2 --cols-${cols} ${classNames} --react`}>{children}</div>;
}
